<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Equipamentos
          </p>
          <div class="heading-elements">
            <i
              class="fas fa-long-arrow-alt-left position-left"
              @click="voltar()"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="file"
                >Escolhe um arquivo CSV <sup class="text-danger">* </sup></label
              >
              <input id="file" type="file" name="file" ref="files" />
              <br />
              <div class="alert-info" style="padding: 10px 0 10px 10px">
                As linhas do arquivo CSV deve ser separado por "," !
              </div>
            </div>
          </div>
        </div>
              
        <div class="box-footer text-center">
          <div class="btn-group">
            <button
              type="button"
              id="cancelButton"
              class="btn btn-warning"
              @click="voltar()"
            >
              Cancelar
            </button>
            <button
              type="button"
              id="gravarButton"
              class="btn btn-success"
              @click="gravar()"
            >
              Gravar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import ToggleButton from 'vue-js-toggle-button';
import EquipamentoActions from "../../actions/EquipamentoActions";

Vue.use(ToggleButton)

export default {
  name: "Importar",
  data() {
    return {
      errorMessage: "",
      tipoArquivo: false
    };
  },
  mounted() {
    this.$parent.$parent.$data.description = "Importar";
  },
  methods: {
    voltar() {
      this.$router.push("/equipamentos");
    },
    gravar() {
      this.$parent.$parent.$data.showModalLoader = true;
      this.errorMessage = "";
      let dataForm = new FormData();

      for (let file of this.$refs.files.files) {
        dataForm.append("file", file);
        dataForm.append("tipo_arquivo", this.tipoArquivo ? 2 : 1);
      }

      EquipamentoActions.importarCSV(
        dataForm,
        this,
      )
      .then(() => {
        this.$parent.$parent.$data.showModalLoader = false
        this.$refs.files.value = ''
        this.$notification.success('Arquivo importado com sucesso !', {
          timer: 10,
          position: 'bottomRight'
        })
      })
      .catch(error => {
        this.$parent.$parent.$data.showModalLoader = false
        let mensagem = 'Erro ao importar arquivo.'

        if (error.response.data.error !== null) {
          mensagem = error.response.data.error === 'token_expired'
            ? 'A sua sessão expirou! Faça login novamente.'
            : error.response.data.error
        }

        this.$notification.error(mensagem, {
          timer: 10,
          position: 'bottomRight'
        })
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/equipamentos/Importar.vue